import React from 'react';
import LoadingComponent from '~/components/LoadingPage';

export default ({ isLoading, children, title }) =>
  isLoading ? <LoadingComponent title={title} /> : children;



// WEBPACK FOOTER //
// ./resources/assets/js/hoc/ContentData.js